import { render } from "./BlockBarWithValue.vue?vue&type=template&id=67edc941"
import script from "./BlockBarWithValue.vue?vue&type=script&lang=js"
export * from "./BlockBarWithValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__